import { Badge, Button, Card, Collapse } from "react-bootstrap"
import { Link } from "react-router-dom"
import { ScrapeEntryType } from "../../../Types/scrapeEntryType"
import { useState } from "react"
import canAccess from "../../../services/accessService/accessService"
import timeService from "../../../services/time/timeService"

export default function ScrapeEntryEntry(props: {
    scrapeEntryData: ScrapeEntryType,
    fullView?: boolean,
    showActions?: boolean,
}) {

    const {
        scrapeEntryData,
        fullView: initialFullView = false,
        showActions = true,
    } = props

    const [fullView, setFullView] = useState(initialFullView)
    const [showRawData, setShowRawData] = useState(false)
    const [showParsedData, setShowParsedData] = useState(false)

    const {
        _id,
        createdDate,
        lastScrape,
        lastParse,
        parsedData,
        rawLines,
        source,
        type,
        dataId,
        success,
        error,
        errorMessage
    } = scrapeEntryData

    const getSuccessVariant = (success: boolean, error: boolean) => {
        if (error) return 'danger'
        if (success) return 'success'
        return 'warning'
    }

    const getStatusText = (success: boolean, error: boolean) => {
        if (error) return 'Error'
        if (success) return 'Success'
        return 'Pending'
    }

    return (
        <Card className="mb-3">
            <Card.Body>
                <Card.Title>
                    {type} - {source}
                </Card.Title>

                <Card.Text className="mb-1 small">
                    <strong>Data ID:</strong> {dataId}
                </Card.Text>
                <Card.Text className="mb-1 small">
                    <strong>Created:</strong> {timeService.getFormattedTime(createdDate)}
                </Card.Text>
                <Card.Text className="mb-1 small">
                    <strong>Last Scrape:</strong> {timeService.getFormattedTime(lastScrape)}
                </Card.Text>
                <Card.Text className="mb-3 small">
                    <strong>Last Parse:</strong> {timeService.getFormattedTime(lastParse)}
                </Card.Text>

                {fullView && (
                    <>
                        <hr />
                        <Card.Subtitle className="mb-2">
                            <strong>Details:</strong>
                        </Card.Subtitle>
                        
                        {errorMessage && (
                            <Card.Text className="mb-2 small text-danger">
                                <strong>Error Message:</strong><br />
                                {errorMessage}
                            </Card.Text>
                        )}

                        <Card.Text className="mb-2 small">
                            <strong>Raw Lines Count:</strong> {rawLines ? rawLines.length : 0}
                        </Card.Text>

                        {rawLines && rawLines.length > 0 && (
                            <div className="mb-3">
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => setShowRawData(!showRawData)}
                                >
                                    {showRawData ? 'Hide' : 'Show'} Raw Data
                                </Button>
                                <Collapse in={showRawData} mountOnEnter unmountOnExit>
                                    <div className="mt-2">
                                        <pre className="bg-light p-2 small" style={{maxHeight: '300px', overflow: 'auto'}}>
                                            {rawLines.join('\n')}
                                        </pre>
                                    </div>
                                </Collapse>
                            </div>
                        )}

                        {parsedData && Object.keys(parsedData).length > 0 && (
                            <div className="mb-3">
                                <Button
                                    variant="outline-info"
                                    size="sm"
                                    onClick={() => setShowParsedData(!showParsedData)}
                                >
                                    {showParsedData ? 'Hide' : 'Show'} Parsed Data
                                </Button>
                                <Collapse in={showParsedData} mountOnEnter unmountOnExit>
                                    <div className="mt-2">
                                        <pre className="bg-light p-2 small" style={{maxHeight: '300px', overflow: 'auto'}}>
                                            {JSON.stringify(parsedData, null, 2)}
                                        </pre>
                                    </div>
                                </Collapse>
                            </div>
                        )}
                    </>
                )}

                {!fullView && (rawLines?.length > 0 || (parsedData && Object.keys(parsedData).length > 0)) && (
                    <Card.Text className="mb-2 small text-muted">
                        {rawLines?.length > 0 && `${rawLines.length} raw lines`}
                        {rawLines?.length > 0 && parsedData && Object.keys(parsedData).length > 0 && " • "}
                        {parsedData && Object.keys(parsedData).length > 0 && "Parsed data available"}
                    </Card.Text>
                )}

            </Card.Body>

            {showActions && (
                <Card.Footer>

                    <div>
                        <Badge bg={getSuccessVariant(success, error)} className="me-2 mb-2">
                            {getStatusText(success, error)}
                        </Badge>
                        <Badge bg="info" className="me-2 mb-2">
                            {type}
                        </Badge>
                        <Badge bg="secondary" className="me-2 mb-2">
                            {source}
                        </Badge>
                    </div>

                    {!initialFullView && canAccess('routes', 'scrape-entry') && (
                        <Link className="btn btn-primary btn-sm me-2 mb-2" to={`/scrape-entry/${_id}`}>
                            View
                        </Link>
                    )}
                    {canAccess('routes', 'edit-scrape-entry') && (
                        <Link className="btn btn-secondary btn-sm me-2 mb-2" to={`/edit-scrape-entry/${_id}`}>
                            Edit
                        </Link>
                    )}
                    {canAccess('routes', 'delete-scrape-entry') && (
                        <Link className="btn btn-danger btn-sm me-2 mb-2" to={`/delete-scrape-entry/${_id}`}>
                            Delete
                        </Link>
                    )}
                    {!initialFullView && (
                        <Button
                            className="me-2 mb-2"
                            variant="secondary"
                            size="sm"
                            onClick={() => setFullView(!fullView)}
                        >
                            {fullView ? 'Hide Details' : 'Show Details'}
                        </Button>
                    )}
                </Card.Footer>
            )}
        </Card>
    )
}